var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"companyBox",staticClass:"mobile-company-box"},_vm._l((_vm.itemList),function(item,index){return _c('div',{key:index,ref:`item${index}`,refInFor:true,staticClass:"mobile-company-item",class:{
      [`mobile-bg${index + 1}`]: true,
      'mobile-active': _vm.isActive(index),
    },on:{"click":function($event){return _vm.handleClick(index)}}},[_c('div',{staticClass:"mobile-content"},[_c('div',{staticClass:"mobile-title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"mobile-text"},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }